import React, { useEffect, useState } from 'react'
import navimage from "../../../../images/Group 1000001625.svg";
import logout from "../../../../images/logout.svg";
import emailonstara from "../../../../images/emailonstara.png";
import bank from "../../../../images/balance.svg";
import email from "../../../../images/Email(2).svg";
import order from "../../../../images/note.svg";
import addaproduct from "../../../../images/add-product (1) 1.svg";
import product from "../../../../images/Vector.svg";
import overview1 from "../../../../images/element-3.svg";
import overviewgrey from "../../../../images/overview.svg";
import image from "../../../../images/gallery.svg"
import { logoutAction } from "../../../redux/slices/userSlices";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import Overview from './Overview';

import EcomSellerDashboard from '../EcomSellerDashboard';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BASEURL;

const SellerNavigationComponent = () => {
    const navigate=useNavigate();
    const dispatch = useDispatch();
    const [activeSection, setActiveSection] = useState("");
    const [overview, setOverview] = useState(false);
    const [products, setProduct] = useState(false);
    const [productlist, setProductlist] = useState(false);
    const [orders, setOrders] = useState(false);
    const [helplines, setHelpline] = useState(false);
    const [account, setAccount] = useState(false);
    const [activeLink, setActiveLink] = useState("");
    const [active, setActive] = useState("overview");

    const [details, setDetails] = useState("");
    
    const state = useSelector((state) => state.sellers);
    const { sellerAuth} = state;
    useEffect(() => {
      const seller=  localStorage.getItem("sellerregisterInfo");
      const sellerInfoObject = JSON.parse(seller);
      console.log(sellerInfoObject?._id); // Check the entire object
    
      const fetchDetails = async () => {
        const response = await axios.post(
          `${baseUrl}/api/reseller/singleuserdetail`,
          {
            reseller: sellerInfoObject?._id,
          }
          );
          setDetails(response.data);
        };
        fetchDetails();
      }, []);
      console.log(details,'detailsss');
    const handleClickproduct = () => {
        setOverview(false);
        setProduct(false);
        setProductlist(true);
        setOrders(false);
        setAccount(false);
        setActiveLink("product");
        navigate("/productlist")
      };
      const handleClickEditProfile = () => {
        setOverview(true);
        setProduct(false);
        setAccount(false);
        setOrders(false);
        setProductlist(false);
        setHelpline(false);
        setActiveLink("overview");
        navigate("/overview")
      };
      const handleClickManageaddress = () => {
        setOverview(false);
        setProduct(true);
        setProductlist(false);
        setAccount(false);
        setActiveLink("addproduct");
        navigate("/addproduct")
      };
      const handleClickHelpline = () => {
        setOverview(false);
        setProduct(false);
        setAccount(false);
        setOrders(false);
        setProductlist(false);
        setHelpline(true);
        setActiveLink("helpline");
        navigate("/helpline")

      };
      const handleClickOrders=()=>{
        setOverview(false);
        setProduct(false);
        setProductlist(false);
        setOrders(true);
        setHelpline(false);
        setAccount(false);
        setActiveLink("orders"); 
        navigate("/orders")

      }
      const handleClickBankaccount=()=>{
        setOverview(false);
        setProduct(false);
        setOrders(false);
        setAccount(true);
        setHelpline(false);
        navigate("/addbankaccount")
        setActiveLink("addbankaccount"); 
      }
  return (
    <div>
           <div
        className="sidebarimagediv"
        // onClick={handleClickEditProfile}
      >
        <img onClick={()=>navigate("/dashboard")} src={navimage} className="onstarasellersidebarimage" />
        <p className="sidemenutext">Menu</p>
        {/* <div>
          {active === "overview" ? (
            <div
              className={`sidemenuoverview active`}
              onClick={handleClickEditProfile}
            >
              <div style={{ display: "flex" }}>
                <img src={overviewgrey} className="overviewimage" />
                <p className="sidemenuoverviewtext">Overview</p>
              </div>
            </div>
          ) : (
            <div
              className={`sidemenuoverview`}
              onClick={handleClickEditProfile}     
              style={{ color: activeLink === "sidemenuoverviewtext" ? "#0b7cc8" : "" }}

            >
              <div style={{ display: "flex" }}> */}
                {/* <img src={overviewgrey} className="overviewimage" /> */}
                {/* <p className="sidemenuoverviewgreytext">Overview</p>
              </div>
            </div>
          )}
        </div> */}
        
        <div style={{ display: "flex" }}>
        <div
            style={{ display: "flex", gap:"20px" }}
            className={`sidemenuproductlist ${
              activeSection === "overview" ? "active" : ""
            }`}
          >
          <img src={overviewgrey} className="overviewimage" />
          <p className="sidemenuoverviewgreytext" onClick={handleClickEditProfile}
         style={{ color: activeLink === "overview" ? "#0099FF" : "" }}
          >Overview</p>
          </div>
        </div>



        <div style={{ display: "flex" }}>
        <div
            style={{ display: "flex", gap:"20px" }}
            className={`sidemenuproductlist ${
              activeSection === "product" ? "active" : ""
            }`}
          >
          <img src={product} className="sidemenuproductimage" />
          <p className="sidemenuproductstext" onClick={handleClickproduct}
         style={{ color: activeLink === "product" ? "#0099FF" : "" }}
          >Products</p>
          </div>
        </div>
        <div style={{ display: "flex" }}>
          <div
            style={{ display: "flex", gap:"20px" }}
            className={`sidemenuaddproduct
             ${
              activeSection === "addproduct" ? "active" : ""
            }`}
          >
            <img src={addaproduct} className="sidemenuaddproductimage" />
            <div className="addproductstext"
             onClick={handleClickManageaddress}
       style={{ color: activeLink === "addproduct" ? "#0099FF" : ""  }}
               >
              Add Products
            </div>
          </div>
        </div>
        <div style={{ display: "flex" }}>
        <div style={{ display: "flex" , gap:"20px" }}  className={`sidemenuhelpline ${
              activeSection === "helpline" ? "active" : ""
            }`}>
          <img src={email} className="sidemenuvariationimage" />
          <p className="variationstext" onClick={handleClickHelpline}
            style={{ color: activeLink === "helpline" ? "#0099FF" : "" }}
            >HelpLine</p>
        </div>
        </div>
        <div style={{ display: "flex", gap:"20px" }}>
          <img src={order} 
           className={`sidemenuvariationimage ${
            activeSection === "orders" ? "active" : ""
          }`} />
          <p className="orderstext" onClick={handleClickOrders}
            style={{ color: activeLink === "orders" ? "#0099FF" : "" }}
            >Orders  & Returns</p>
        </div>
        <div style={{ display: "flex"  }}>
          <div style={{ display: "flex" ,gap:"20px" }}  className={`sidemenuaddbankaccount ${
              activeSection === "addbankaccount" ? "active" : ""
            }`}>
          <img src={bank} className="sidemenubankimage" />
          <p className="bankaccountstext"  onClick={handleClickBankaccount}
                  style={{ color: activeLink === "addbankaccount" ? "#0099FF" : "" }}
>Bank Accounts</p>

          </div>
        </div>
          {/* <div style={{display:"flex"}}>
            <img src={emailonstara} className="emailonstara"/>
            <div>
            <p className="facingtrouble"> ?</p>
<p className="onstaraemailid">Support@onstara.com</p>
            </div>
          </div> */}
        {/* <p className="sidebarprofiletext">Profile</p> */}

        <p className="sidebarprofiletextOne">Profile</p>
            <div className="profile-section">
              <div className="orderimagedivOne">
                <img src={image} alt="Profile" className="profile-photo" /> </div>
                <div className="profile-details">
                    <p className="profile-name">{details[0]?.Fullname} </p>
                    <p className="profile-company">{details[0]?.Storename}</p>
                </div>
            </div>

        <div style={{ display: "flex" }}
          onClick={() => {
            localStorage.removeItem("sellerregisterInfo");
            localStorage.removeItem("phoneNumber");
            navigate("/");
          }}
        >
          <img src={logout} className="sidemenulogoutimage" />
          <p className="sidebarlogouttext">Logout</p>
        </div>
      </div>
    </div>
  )
}

export default SellerNavigationComponent
